module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 text-center"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = true
      }
    }
  }, [(_vm.user.profile_pic != '') ? _c('img', {
    staticClass: "img-responsive rounded-circle",
    attrs: {
      "src": _vm.user.profile_pic
    }
  }) : _c('img', {
    staticClass: "img-responsive rounded-circle",
    attrs: {
      "src": require("../../assets/img/cats/03.jpg")
    }
  }), _vm._v(" "), _c('small', [_vm._v("點擊更換大頭照")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("職位")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.title),
      expression: "user.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("聯絡電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateUser(_vm.user.user_token)
      }
    }
  }, [_vm._v("修改")])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "text-left"
  }, [_vm._v("個人業績目標\n                  "), (_vm.user.sales_target) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("目前的每月預定目標： $ " + _vm._s(_vm.user.sales_target.toLocaleString()) + " \n                    "), _c('button', {
    staticClass: "btn btn-success btn-xs",
    on: {
      "click": function($event) {
        _vm.setMonthTarget = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [(!_vm.user.sales_target) ? _c('div', {
    staticClass: "widget-content"
  }, [_vm._v("\n                你可以設定你的預設業績目標，將會自動產生每個月的業績目標。"), _c('br'), _vm._v("你也可以之後依照狀況調整每個月的業績目標\n                "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.setMonthTarget = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" 設定目標")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.target_year) + " 的每月業績目標")]), _vm._v(" "), _c('h4', [_vm._v("目標：$" + _vm._s(_vm.totalTarget.toLocaleString()) + " , 達成：$" + _vm._s(_vm.totalAmount.toLocaleString()) + " , 達成率：" + _vm._s(parseInt(_vm.totalAmount * 100 / _vm.totalTarget || 0)) + "%")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filterTargets), function(target) {
    return _c('tr', {
      class: {
        'table-success': _vm.thisMonth(target)
      }
    }, [_c('td', [_vm._v(_vm._s(target.month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(target.deal_number))]), _vm._v(" "), _c('td', [(_vm.target_edit == 'no' || _vm.target_edit != ('target_value' + target.id)) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.editTextClick(('target_value' + target.id), target)
        }
      }
    }, [_vm._v("$" + _vm._s(target.deal_amount.toLocaleString()) + " / $" + _vm._s(target.target.toLocaleString()) + " "), _c('i', {
      staticClass: "fa fa-pen"
    })]) : _vm._e(), _vm._v(" "), (_vm.target_edit == ('target_value' + target.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.temp_target),
        expression: "temp_target"
      }],
      ref: ('target_value' + target.id),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.temp_target)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.saveTarget(target)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.temp_target = $event.target.value
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(target.target != 0) ? _c('span', [_vm._v(_vm._s(parseInt(target.deal_amount * 100 / target.target)) + "%")]) : _c('span', [_vm._v("-")])])])
  }))])])])])])])]), _vm._v(" "), (_vm.uploadAvatarModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.uploadAvatarModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              上傳新的大頭照\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/users/update_profile_pic',
      "headers": _vm.auth_token,
      "maxFileSizeInMB": 12
    },
    on: {
      "vdropzone-success": _vm.vsuccess
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.setMonthTarget) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.setMonthTarget = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              設定你的每月目標\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setMonthTarget = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("月目標(請輸入數字)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.sales_target),
      expression: "user.sales_target"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "ex: 1200000"
    },
    domProps: {
      "value": (_vm.user.sales_target)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.sales_target = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.updateUser(_vm.user.user_token);
        _vm.setMonthTarget = false
      }
    }
  }, [_vm._v("\n                確定\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.setMonthTarget = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("個人資訊")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("月份")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("達成件數")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("達成金額/目標")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("月達成率")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1d8b9b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserProfile.vue
// module id = 700
// module chunks = 4